import React from "react";
import { Z_APPS_SHORT_HOST } from "../../../../common/consts";
import { ATargetBlank } from "../../Link/ATargetBlank";
import { Link } from "../../Link/LinkWithYouTube";
import { linkShadowStyle } from "./linkShadowStyle";

export const LinkRender = (props: {
    href: string;
    children: React.ReactNode;
}) => <LinkRenderBase {...props} />;

export const LinkRenderNoExternal = (props: {
    href: string;
    children: React.ReactNode;
}) => <LinkRenderBase {...props} noExternalLink />;

export const LinkWithoutShadowRender = (props: {
    href: string;
    children: React.ReactNode;
}) => <LinkRenderBase {...props} noLinkShadow />;

const LinkRenderBase = ({
    href,
    children,
    noLinkShadow,
    noExternalLink,
}: {
    href: string;
    children: React.ReactNode;
    noLinkShadow?: boolean;
    noExternalLink?: boolean;
}) => {
    if (href.startsWith("F=")) {
        return (
            <ruby>
                {children}
                <rt style={{ textShadow: "none", padding: "4px 0 2px" }}>
                    {href.replace("F=", "")}
                </rt>
            </ruby>
        );
    }

    const style = noLinkShadow ? undefined : linkShadowStyle;

    if (href.includes("https://") || href.includes("http://")) {
        if (noExternalLink && !href.includes(Z_APPS_SHORT_HOST)) {
            return <span>{children}</span>;
        }
        return (
            <ATargetBlank href={href} style={style}>
                {children}
            </ATargetBlank>
        );
    }

    if (window.location.pathname.startsWith("/articlesEdit/")) {
        return (
            <ATargetBlank
                href={`https://articles.lingual-ninja.com${href}`}
                style={style}
            >
                {children}
            </ATargetBlank>
        );
    }

    return (
        <Link to={href} style={style}>
            {children}
        </Link>
    );
};
